import * as Sentry from '@sentry/browser';

const SentryConfig = () => {
  // 在开发、测试和模拟环境或本地开发时不初始化 Sentry
  if (['dev', 'test', 'mock'].includes(process.env.VUE_APP_ENV) || window.location.hostname === 'localhost') {
    return
  }
  try {
    Sentry.init({
      dsn: 'https://c514c0c114cf43d9be254e04512d92cc@ideas.ibaiqiu.com/19',
      environment: process.env.NODE_ENV === 'production' ? 'OTWEB-PROD' : 'OTWEB-UAT',
      attachStacktrace: true,
      tracesSampleRate: 1.0,
      debug: false,
      beforeSend(event) {
        try {
          // 检查事件类型，只在捕获异常时设置用户信息
          const localStorageUserInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null
          const token = localStorage.getItem('token') || {}

          if (localStorageUserInfo) {
            const userInfo = {
              username: localStorageUserInfo.username,
              mobile: localStorageUserInfo.mobile,
              birthday: localStorageUserInfo.birthday,
              levelName: localStorageUserInfo.crm.levelName,
              accountId: localStorageUserInfo.crm.accountId,
              gender: Number(localStorageUserInfo.gender) === 1 ? '先生' : '女士',
            }
            event.extra = { ...event.extra, userInfo };
            if (token) {
              event.user = { ...event.user, id: token };
            }
          }
        } catch (error) {
          console.error('Error parsing userInfo from localStorage', error);
        }
        return event
      }
    })
    Sentry.addBreadcrumb()
  } catch (error) {
    console.error('SentryConfig Failed', error);
  }
}

function captureWithTag(err, tag) {
  Sentry?.withScope((scope) => {
    scope.setTag(tag, 'yes')
    Sentry.captureException(err)
  })
}

// 表单上报
function captureFormError(err) {
  captureWithTag(err, 'formError')
}

// 手动上报
function captureManualError(err) {
  captureWithTag(err, 'manualError')
}


export default SentryConfig
export { captureWithTag, captureFormError, captureManualError }


